import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Entry_task } from '../models/entry_task';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class EntryTaskService {

  constructor(private http: HttpClient) { }

	getList(): Promise<Entry_task[]> {
		return this.getListWithRest("");
	}

  private getListWithRest(rest_url: string) : Promise<Entry_task[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'entry_tasks/' + rest_url).subscribe((response:any) => {
			if(response.type == 'entry_tasks' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  hideTask(task: Entry_task): Promise<boolean> {
  	let put_data = {
          data: {type: 'hide_task_request',
          attributes: { task_id: task.id }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'entry_tasks',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='hide_task_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  completeTask(task: Entry_task): Promise<boolean> {
    let put_data = {
          data: {type: 'task_completion_request',
          attributes: { task_id: task.id }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'entry_tasks',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='task_completion_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  convertEntry(task_id: string, user_id: string): Promise<boolean> {
      let post_data = {
          data: {
            type: 'entry_conversion_request',
            attributes: { task_id: task_id, user_id: user_id }
            }
        };

    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'entry_tasks',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if(response.data && response.type=='entry_conversion_response') {
               resolve(response.data);
               }  else {
                 reject(response);
               }

        }, error => {
          if(error instanceof HttpErrorResponse){
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });
  }

}
